import { render, staticRenderFns } from "./UploadQueue.vue?vue&type=template&id=b54678e2&scoped=true"
import script from "./UploadQueue.vue?vue&type=script&lang=ts"
export * from "./UploadQueue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54678e2",
  null
  
)

export default component.exports